import { useEffect } from 'react';

const useIntersectionObserver = (
  ref: React.RefObject<Element | null>,
  onIntersect?: () => void,
  options: IntersectionObserverInit = { threshold: 0.6 },
) => {
  useEffect(() => {
    const element = ref.current;

    if (!element || !onIntersect) {
      return () => null;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onIntersect();
        }
      });
    }, options);

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [ref, onIntersect, options]);
};

export { useIntersectionObserver };
